// extracted by mini-css-extract-plugin
module.exports = {"previewButton":"_3Q7hy","addToCart":"_3oVHA"};